import React from 'react';
import {Text, View, StyleSheet } from '@react-pdf/renderer';
import { format } from 'date-fns'

const styles = StyleSheet.create({
   
    titleContainer:{
        flexDirection: 'row',
        marginTop: 12
    },
    reportTitle:{
        fontSize: 12,
        textAlign: 'center'
    }
  });


  const QuoteMsg = () => (
    <View style={styles.titleContainer}>
        <Text style={styles.reportTitle}>Generated on {format(new Date(), 'dd.MM.yyyy, HH:mm:ss')}</Text>
    </View>
  );
  
  export default QuoteMsg